import { Link } from 'react-router-dom';
import { Button } from '@crazyegginc/hatch';

import { DashboardPage } from '/src/components/Page';
import { SEO } from '/src/components/SEO';
import { DashHeader } from '/src/components/headers/DashHeader';

import { usePermissions } from '/src/hooks';
import { DashboardPaywall } from '/src/features/_global/paywalls/DashboardPaywall';
import { FEATURES } from '/src/features/_global/constants';
import { getFeatureName } from '/src/features/_global/utils';

import { FunnelsDashboardContent } from '../components/dashboard/FunnelsDashboardContent';
import { ReactComponent as PlusIcon } from '@crazyegginc/hatch/dist/images/icon-plus.svg';

// eslint-disable-next-line no-restricted-syntax
export default function FunnelsDashboard() {
  const permissions = usePermissions();

  const { allowed: canViewDashboard, reason } = permissions.can('view', FEATURES.FUNNELS);
  const canEditFunnel = permissions.can('edit', FEATURES.FUNNELS).allowed;

  if (!canViewDashboard) {
    return <DashboardPaywall feature={FEATURES.FUNNELS} reason={reason} paddingLeftRight="40px" />;
  }

  return (
    <DashboardPage>
      <SEO title={getFeatureName(FEATURES.FUNNELS)} />
      <DashHeader
        title={getFeatureName(FEATURES.FUNNELS)}
        actionButton={
          canEditFunnel ? (
            <Button
              size="xl"
              component={Link}
              to="/funnels/edit"
              leftIcon={<PlusIcon className="mr-2 h-2.5 w-2.5 fill-current" />}
            >
              Create New Funnel
            </Button>
          ) : null
        }
      />
      <FunnelsDashboardContent />
    </DashboardPage>
  );
}
